module.exports = __webpack_public_path__ + "img/9788959522316.72bd94e9.jpg";